/* eslint-disable import/no-cycle,import/named */
import {
  AnyAction, combineReducers, configureStore, ThunkDispatch,
} from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { PROCESS_ENVIRONMENTS } from '../constants';
import { floorReducer } from '../../domain/projects/store/slice';
import { lotReducer } from '../../domain/lotEditor/store/editor/slice';
import { locateTypicalReducer } from '../../domain/locateTypical/store/slice';
import { lotGuiSelectorReducer } from '../../domain/lotEditor/store/gui/slice';

export const rootReducer = combineReducers({
  floorReducer,
  lotReducer,
  locateTypicalReducer,
  lotGuiSelectorReducer,
});
export const createStore = (preloadedState?: any) => configureStore<IRootState, AnyAction, any>({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware: any) => getDefaultMiddleware({
    serializableCheck: false,
    immutableCheck: false,
  }),
  devTools: process.env.NODE_ENV !== PROCESS_ENVIRONMENTS.PROD,
  preloadedState,
});

const Store = createStore();

export default Store;

// export type AppDispatch = typeof Store.dispatch;
export type AppThunkDispatch = ThunkDispatch<IRootState, any, AnyAction>;
export const useAppDispatch = () => useDispatch<AppThunkDispatch>();
export type IRootState = ReturnType<typeof rootReducer>;
